import SqFetch from 'application/fetch';
import { getLocaleString } from 'utilities/locales';

export default class ProductClient {
  constructor(slug, locale = getLocaleString()) {
    this.slug = slug;
    this.locale = locale;
    this.baseUrl = `/shop/api/v1/products/${this.slug}`;
  }

  _handleResponse(response) {
    if (!response.ok) {
      throw new Error(response);
    }
    return response.json();
  }

  fetchUpsells() {
    return SqFetch.get(`${this.baseUrl}/upsells?locale=${this.locale}`).then(
      this._handleResponse,
    );
  }

  createLead(email) {
    return SqFetch.post(`${this.baseUrl}/lead`, { email }).then(
      this._handleResponse,
    );
  }
}
